module.exports = __webpack_public_path__ + "img/1f649.0bc7176.svg";